export default __webpack_public_path__ + "static/media/product-05 (2).83c84040.jpg";